import { apiConstants } from "../../../../utils/apiConstants";
import { apiTypes } from "../../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../../utils/getAxiosCancelToken";
import apiRequestType from "../../../apiRequestType";

let cancelToken;

const getFilterUserVisualReport = (data) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.POST,
    apiConstants.REPORT.GRAPHICAL_REPORT.FILTER_USER_VISUAL_REPORT,
    data,
    cancelToken
  );
};

export default getFilterUserVisualReport;
